import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'power_one'
})


function commonPowOne (q, min, max) {
    let base = random.fairChoiceInt(min, max)
    q.addMathFormula(base + '^\\color{blue}[1]')
    q.answer = base
}


//S'assurer que la puissance de 1 est bien comprise, base positive
level.addQuestion({
    generator: function (q) {
        commonPowOne(q, 7, 100)
    },
    times: 1

})


//S'assurer que la puissance de 1 est bien comprise, base négative
level.addQuestion({
    generator: function (q) {
        commonPowOne(q, -100, -7)
    },
    times: 1

})


export default level